import { takeLatest } from 'redux-saga/effects'
import { CLONE_WHITELABEL } from 'app/redux-base/actions/configurator'
import cloneWL from './cloneWL'

export default function* watchCloneWL() {
  yield takeLatest(CLONE_WHITELABEL.REQUEST, cloneWL)
}
